import { EProjectFilters } from 'types/filters';

export const getProjectFiltersKey = (projectId: number, projectType: EProjectFilters): string =>
  `${projectId}:${projectType}`;
